import { Component, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-enterprise';
import { Subscription } from 'rxjs';
import { CellRendererService } from 'src/app/common/ag-grid-table/cell-renderers/dynamic.cell-renderer';
import { ActionsCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/actions/actions.component';
import { TextCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/text/text.component';
import { AgGridToolsService } from 'src/app/common/ag-grid-table/services/ag-grid-tools.service';
import { TableCommunicationService } from 'src/app/common/ag-grid-table/services/table-communication.service';
import { UtilitiesService } from 'src/app/common/services/utilities.service';

@Component({
  selector: 'app-client-strings-ag-grid',
  templateUrl: './client-strings-ag-grid.component.html',
  styleUrls: ['./client-strings-ag-grid.component.sass']
})
export class ClientStringsTableAgGridComponent implements OnInit {
  public entity = 'localization/client-strings';
  public columnDefs: ColDef[] = [];
  public bulkUpdateColDefs: any[] = [];
  public columnSelection: string;
  public autopopulateSelect = '';
  public buildParams = {};
  public tableParams = {};
  public displayEditDialog = false;
  public editRecord: any;

  private editClientStringSubscription: Subscription;

  constructor(
    private agGridToolsService: AgGridToolsService,
    private tableCommunicationService: TableCommunicationService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.initializeColumnDefs();
    this.initializeTableParams();
    this.setupSubscriptions();
  }

  private initializeColumnDefs(): void {
    this.columnDefs = [
      {
        headerName: 'Actions',
        field: 'actions',
        cellRenderer: ActionsCellRendererComponent,
        pinned: 'right',
        width: 120,
        resizable: true,
        cellRendererParams: {
          enableDuplicateFeature: false
        }
      },
      {
        headerName: 'Record ID',
        field: 'id',
        width: 400,
        headerCheckboxSelection: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        checkboxSelection: true,
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'English',
        field: 'Source_en',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        minWidth: 300,
        autoHeight: true
      },
      {
        headerName: 'French (France)',
        field: 'Target_frFR',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
      },
      {
        headerName: 'Spanish (Mexico)',
        field: 'Target_esMX',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
      },
      {
        headerName: 'German',
        field: 'Target_deDE',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
      },
      {
        headerName: 'Verified',
        field: 'verified',
        cellRenderer: TextCellRendererComponent,
        cellRendererParams: {
          onLabel: 'Verified',
          offLabel: 'Not Verified',
          isBoolean: true
        },
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: [true, false],
          valueFormatter: (params: any) => params.value ? 'Verified' : 'Not Verified'
        },
        floatingFilter: true,
      },
    ];

    this.columnSelection = this.agGridToolsService.getColumnFieldNamesFromCols(this.columnDefs);
  }

  private initializeTableParams(): void {
    this.tableParams = {
      customName: "Client Strings",
      customButtons: ['addString', 'importCsvClientStrings'],
      hideBulkActions: true,
      hideExport: true,
      hideBuild: true,
      hidePromotion: true,
      hideAdd: true,
      customActionsLabel: 'Client Strings Actions',
      customActionButtons: ['bulkTranslateGeneralStrings', 'findReplaceClientStrings'],
    };
  }

  private setupSubscriptions(): void {
    this.editClientStringSubscription = this.tableCommunicationService.editClientString$.subscribe((show: any) => {
      this.displayEditDialog = show.display;
      this.editRecord = show.record;
    });
  }

  public hideStringDialog(): void {
    this.displayEditDialog = false;
  }

  public onStringFormSubmitted(): void {
    this.tableCommunicationService.emitEvent('reloadDataSource');
  }
}
